import { z } from 'zod'

export const STRATALYST_AGENT_RUN_CONTRACT_VERSION = '1.0.0' as const
export const stratalystAgentRunResponseSchema = z.unknown()
export type StratalystAgentRunResponse = z.infer<typeof stratalystAgentRunResponseSchema>
